<div
  class="rebates-banner"
  data-cy="rebates-banner"
  *ngIf="selectedIncentiveProgram"
>
  <ng-container>
    <div class="rebates-content" [class]="bannerInformation.className">
      <div class="rebates-amount">
        {{ bannerInformation.amount | formatCurrencyAndDecimalPipe: '1.0-0' }}
      </div>
      <div class="rebates-text">
        <span class="rebates-title">
          {{ bannerInformation.title | translate }}
        </span>
        <span class="rebates-subtext">
          {{ bannerInformation.subtext | translate }}
        </span>
      </div>
      <div class="rebates-action">
        <ion-icon
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum?.mobile
          "
          src="assets/icon/chevron-right-fill-white.svg"
          (click)="navigateToRebates()"
        ></ion-icon>
        <ion-button
          *ngIf="
            platformService?.platformType !==
            platformService?.platformEnum?.mobile
          "
          (click)="navigateToRebates()"
          class="usf-outline-green-button"
        >
          {{ 'i18n.home.incentivesBanner.button' | translate }}
        </ion-button>
      </div>
    </div>
  </ng-container>
</div>
